<template>
  <v-container fluid>
    <p v-if="!isAuthenticated">Please log in</p>
    <v-row class="justify-center" v-show="isAuthenticated">
      <v-col cols="6">
        <ProductMatchingEnrichmentOverview
          @select-participant="handleSelectParticipant"
          @select-brand="handleSelectBrand"
          @add-brand-to-selection="handleAddBrand"
          @select-no-brand="handleSelectNoBrand"
        />
      </v-col>
      <v-col cols="6">
        <DataSelectionTable
          ref="dataSelectionTable"
          v-if="allParticipants?.length"
          @selection-loaded="onSelectionLoaded"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import ALL_PARTICIPANTS from '@/graphql/Participant/allParticipants.gql'
import { inject } from 'vue'
import ProductMatchingEnrichmentOverview from '@/components/ProductMatchingEnrichmentOverview.vue'
import DataSelectionTable from '@/components/DataSelectionTable.vue'

export default {
  name: 'HomePage',
  setup: () => ({ rc: inject('rc') }),
  components: {
    ProductMatchingEnrichmentOverview,
    DataSelectionTable
  },
  data () {
    return {
      allParticipants: []
    }
  },
  methods: {
    onSelectionLoaded (config) {
      // Selection has been loaded and locked
      // The App.vue queries will now fire based on selectionConfig
      console.log('Selection loaded:', config)
    },
    handleSelectParticipant ({ participantSk }) {
      // Set row 3 (Participant / Participant) with the selected participant
      this.$refs.dataSelectionTable?.setSelectionFromOverview(3, {
        participantSk,
        autoLoad: false  // Don't auto-load, let user click the button
      })
    },
    handleSelectBrand ({ brandSk }) {
      // Set row 4 with the selected brand
      this.$refs.dataSelectionTable?.setSelectionFromOverview(4, {
        brandSks: [brandSk],
        autoLoad: false
      })
    },
    handleAddBrand ({ brandSk }) {
      // Add brand to current selection
      this.$refs.dataSelectionTable?.addBrandToCurrentSelection(brandSk)
    },
    handleSelectNoBrand ({ participantSk }) {
      // Set row 5 (No Brand + Participant)
      this.$refs.dataSelectionTable?.setSelectionFromOverview(5, {
        participantSk,
        autoLoad: false
      })
    }
  },
  computed: {
    ...mapState(['currentParticipantSk', 'selectionConfig']),
    isAuthenticated () {
      return this.$auth0.isAuthenticated.value
    },
    currentParticipantName () {
      return (this.allParticipants && this.currentParticipantSk)
        ? this.allParticipants?.find(x => x.Participant_SK === this.currentParticipantSk)?.Participant_Name
        : ''
    }
  },
  apollo: {
    allParticipants: {
      query: ALL_PARTICIPANTS,
      skip () {
        return !this.isAuthenticated
      }
    }
  }
}
</script>
